import { plainToInstance } from 'class-transformer'

import { DelayDateType } from '../../DelayTypes'
import { DelayType } from '../../DelayTypes/types'
import { ProxyBaseDelayType } from './ProxyBaseDelayType'

export class ProxyDelayDateType extends ProxyBaseDelayType {
  type: DelayType.Date = DelayType.Date
  time: string

  constructor({ time }: DelayDateType) {
    super()

    this.time = time
  }

  setTime(time: string): void {
    this.time = time
  }

  getModel(): DelayDateType {
    return plainToInstance(DelayDateType, this)
  }
}
